import { EditorType } from "@kaggle/sdk/kernels";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";
import { ActionKey, SessionAction } from "../../../actions/session";
import { getJupyterUrlSourceType } from "../../../selectors/jupyter";

export const sourceType = (
  // TODO(cochamberlain): Introduce alternate for this when not in the Jupyter frame.
  state: EditorType = getJupyterUrlSourceType(window.location.search),
  action: SessionAction | NotebookAction
) => {
  switch (action.type) {
    case ActionKey.SET_SESSION_STATE:
      return action.payload.session.sourceType;
    case NotebookActionKey.SET_DRAFT_SPEC:
      const { entity } = action.payload;
      if (!entity || !entity.blob || !entity.blob.settings) {
        return state;
      }
      return action.payload.entity!.blob!.settings!.sourceType;
    default:
      return state;
  }
};
